(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aurrelle-buy-now-checkout"] && !Shopify.designMode) return;
  try {
    (() => {
    let busy = false;
    const selector = '[data-lucine-buy-now], [data-aurrelle-checkout], [data-aurrelle-final-buy], a.button[href*="/products/lucine-infrasonic-dual-action-hair-scalp-renewal-dryer"]';
    const config = () => document.querySelector('[data-aurrelle-checkout-config]');
    const checkout = async (button) => {
      const settings = config();
      if (!settings || busy || settings.dataset.available !== 'true' || button.disabled) return;
      const mainButton = document.querySelector('[data-lucine-buy-now]');
      const form = button.form || (mainButton && mainButton.form);
      if (form && !form.reportValidity()) return;
      const data = form ? new FormData(form) : new FormData();
      const variant = form && form.querySelector('[name="id"]');
      data.set('id', variant ? variant.value : settings.dataset.variantId);
      if (!data.get('quantity')) data.set('quantity', '1');
      data.delete('sections');
      data.delete('sections_url');
      let message = document.querySelector('[data-aurrelle-checkout-error]');
      if (message) message.remove();
      busy = true;
      button.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(settings.dataset.addUrl, { method: 'POST', body: data, credentials: 'same-origin', headers: { Accept: 'application/json' } });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || settings.dataset.error);
        const preview = [...document.querySelectorAll('aurrelle-discount-preview')].find(item => !item.closest('aurrelle-empty-cart'));
        const code = preview ? await preview.checkoutCode() : '';
        const target = new URL(settings.dataset.checkoutUrl, window.location.origin);
        if (code) target.searchParams.set('discount', code);
        window.location.assign(target.href);
      } catch (error) {
        message = document.createElement('p');
        message.dataset.aurrelleCheckoutError = '';
        message.setAttribute('role', 'alert');
        message.className = 'alert alert--error text-sm';
        message.textContent = error.message || settings.dataset.error;
        button.insertAdjacentElement('afterend', message);
        busy = false;
        button.removeAttribute('aria-busy');
      }
    };
    document.addEventListener('click', (event) => {
      const button = event.target.closest(selector);
      if (!button || !config() || document.body.classList.contains('template-index')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      checkout(button);
    }, true);
    document.addEventListener('submit', (event) => {
      const button = event.target.querySelector('[data-lucine-buy-now]');
      if (!button || !config() || document.body.classList.contains('template-index')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      checkout(button);
    }, true);
    const labelLinks = () => {
      const settings = config();
      if (!settings || document.body.classList.contains('template-index')) return;
      document.querySelectorAll('a.button[href*="/products/lucine-infrasonic-dual-action-hair-scalp-renewal-dryer"]').forEach((link) => {
        const text = link.querySelector('.btn-text') || link;
        text.textContent = settings.dataset.label;
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', labelLinks, { once: true });
    else labelLinks();
    document.addEventListener('shopify:section:load', labelLinks);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aurrelle-display-currency"] && !Shopify.designMode) return;
  try {
    (() => {
    const config = document.querySelector('[data-aurrelle-display-currency]');
    if (!config) return;

    const currency = config.dataset.currency;
    const rate = Number(config.dataset.rate);
    if (!currency || !Number.isFinite(rate)) return;

    const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency,
      minimumFractionDigits: 3,
      maximumFractionDigits: 3
    });

    const patterns = [
      /\b(?:AED|Dhs?\.?)\s*([\d,]+(?:\.\d+)?)/gi,
      /([\d,]+(?:\.\d+)?)\s*(?:AED|Dhs?\.?)\b/gi,
      /د\.إ\s*([\d,]+(?:\.\d+)?)/gi
    ];

    const convertAmount = (value) => {
      const amount = Number(value.replaceAll(',', ''));
      return Number.isFinite(amount) ? formatter.format(amount * rate) : value;
    };

    const convertText = (value) => {
      let converted = value;
      patterns.forEach((pattern) => {
        converted = converted.replace(pattern, (_, amount) => convertAmount(amount));
      });
      return converted.replace(/\(AED[^)]*\)/g, `(${currency})`);
    };

    const shouldSkip = (node) => {
      const parent = node.parentElement;
      if (!parent) return true;
      if (parent.closest('[data-aurrelle-display-currency]')) return true;
      return ['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA', 'OPTION', 'CODE', 'PRE'].includes(parent.tagName);
    };

    const convertNode = (node) => {
      if (shouldSkip(node)) return;
      const converted = convertText(node.nodeValue || '');
      if (converted !== node.nodeValue) node.nodeValue = converted;
    };

    const convertTree = (root) => {
      if (root.nodeType === Node.TEXT_NODE) {
        convertNode(root);
        return;
      }

      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) convertNode(node);
    };

    convertTree(document.body);

    new MutationObserver((records) => {
      records.forEach((record) => {
        record.addedNodes.forEach(convertTree);
      });
    }).observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aurrelle-expert-perspectives"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('aurrelle-expert-carousel')){
  customElements.define('aurrelle-expert-carousel',class extends HTMLElement{
    connectedCallback(){
      if(this.expertReady)return;
      this.expertReady=true;
      const slides=[...this.querySelectorAll('[data-expert-slide]')];
      if(!slides.length)return;
      const motion=window.matchMedia('(prefers-reduced-motion:reduce)');
      const abort=new AbortController();
      const options={signal:abort.signal};
      let index=0,paused=motion.matches,visible=false,timer;
      const pause=this.querySelector('[data-expert-pause]');
      const updatePause=()=>{
        pause.setAttribute('aria-pressed',String(paused));
        pause.setAttribute('aria-label',paused?this.dataset.play:this.dataset.pause);
        pause.firstElementChild.textContent=paused?'▶':'Ⅱ';
      };
      const show=(next)=>{
        index=(next+slides.length)%slides.length;
        slides.forEach((slide,i)=>{slide.hidden=i!==index;});
        const portrait=slides[index].querySelector('[data-expert-portrait]');
        if(portrait&&!portrait.querySelector('img')){
          const img=document.createElement('img');
          img.src=portrait.dataset.expertPortrait;
          img.alt=portrait.dataset.expertAlt;
          img.width=80;img.height=80;img.loading='lazy';img.decoding='async';
          portrait.append(img);
        }
      };
      const schedule=()=>{
        clearInterval(timer);
        if(paused||!visible||document.hidden)return;
        timer=setInterval(()=>{
          if(!this.matches(':hover')&&!this.contains(document.activeElement))show(index+1);
        },6000);
      };
      this.querySelector('[data-expert-next]').addEventListener('click',()=>{show(index+1);schedule();},options);
      this.querySelector('[data-expert-prev]').addEventListener('click',()=>{show(index-1);schedule();},options);
      pause.addEventListener('click',()=>{paused=!paused;updatePause();schedule();},options);
      document.addEventListener('visibilitychange',schedule,options);
      motion.addEventListener('change',()=>{paused=motion.matches;updatePause();schedule();},options);
      const observer=new IntersectionObserver(entries=>{visible=entries.some(e=>e.isIntersecting);schedule();},{threshold:.15});
      observer.observe(this);
      this.expertCleanup=()=>{clearInterval(timer);observer.disconnect();abort.abort();this.expertReady=false;};
      updatePause();show(0);
    }
    disconnectedCallback(){this.expertCleanup?.();}
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aurrelle-product-conversion"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeStickyPurchaseBar = (root = document) => {
      const stickyCard = root.querySelector('[data-aurrelle-sticky-card]')
        || document.querySelector('[data-aurrelle-sticky-card]');
      const mainBuyButton = root.querySelector('[data-lucine-buy-now]')
        || document.querySelector('[data-lucine-buy-now]');

      if (!stickyCard || !mainBuyButton || stickyCard.dataset.aurrelleStickyReady === 'true') return;

      stickyCard.dataset.aurrelleStickyReady = 'true';

      const setMainButtonVisibility = (isVisible) => {
        stickyCard.dataset.mainBuyVisible = isVisible ? 'true' : 'false';
      };

      const mainButtonRect = mainBuyButton.getBoundingClientRect();
      setMainButtonVisibility(mainButtonRect.bottom > 0 && mainButtonRect.top < window.innerHeight);

      const observer = new IntersectionObserver((entries) => {
        setMainButtonVisibility(entries.some((entry) => entry.isIntersecting));
      }, { threshold: 0.01 });

      observer.observe(mainBuyButton);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeStickyPurchaseBar(), { once: true });
    } else {
      initializeStickyPurchaseBar();
    }

    document.addEventListener('shopify:section:load', (event) => initializeStickyPurchaseBar(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aurrelle-unboxing-gallery"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('aurrelle-unboxing-gallery'))customElements.define('aurrelle-unboxing-gallery',class extends HTMLElement{
  connectedCallback(){
    if(this.storyReady)return;
    this.storyReady=true;
    const slides=[...this.querySelectorAll('[data-story-slide]')],thumbs=[...this.querySelectorAll('[data-story-index]')];
    const pause=this.querySelector('[data-story-pause]'),dialog=this.querySelector('[data-story-dialog]'),source=this.querySelector('[data-story-source]');
    const motion=matchMedia('(prefers-reduced-motion:reduce)'),abort=new AbortController(),options={signal:abort.signal};
    let index=0,paused=motion.matches,visible=false,timer,start;
    const sync=()=>{pause.setAttribute('aria-pressed',String(paused));pause.setAttribute('aria-label',paused?this.dataset.play:this.dataset.pause);pause.firstElementChild.textContent=paused?'▶':'Ⅱ';};
    const show=next=>{
      index=(next+slides.length)%slides.length;
      slides.forEach((el,i)=>{el.hidden=i!==index;});
      thumbs.forEach((el,i)=>el.setAttribute('aria-pressed',String(i===index)));
      this.querySelector('[data-story-caption]').textContent=slides[index].getAttribute('aria-label');
      source.hidden=index<5;
      source.href=index===7?'https://doi.org/10.1155/dth/6621458':'https://doi.org/10.1007/s40257-013-0060-6';
    };
    const schedule=()=>{
      clearInterval(timer);
      if(paused||!visible||document.hidden||dialog.open)return;
      timer=setInterval(()=>{if(!this.matches(':hover')&&!this.contains(document.activeElement))show(index+1);},Number(this.dataset.interval)||5000);
    };
    const move=next=>{show(next);schedule();};
    this.querySelector('[data-story-next]').addEventListener('click',()=>move(index+1),options);
    this.querySelector('[data-story-prev]').addEventListener('click',()=>move(index-1),options);
    thumbs.forEach((el,i)=>el.addEventListener('click',()=>move(i),options));
    pause.addEventListener('click',()=>{paused=!paused;sync();schedule();},options);
    this.querySelector('[data-story-zoom]').addEventListener('click',()=>{
      const original=slides[index].querySelector('img'),expanded=this.querySelector('[data-story-expanded]');
      expanded.src=original.src;expanded.alt=original.alt;dialog.showModal();schedule();
    },options);
    this.querySelector('[data-story-close]').addEventListener('click',()=>dialog.close(),options);
    dialog.addEventListener('close',schedule,options);
    const stage=this.querySelector('.aur-story__stage');
    stage.addEventListener('pointerdown',e=>{start={x:e.clientX,y:e.clientY};},options);
    stage.addEventListener('pointerup',e=>{
      if(!start)return;
      const dx=e.clientX-start.x,dy=e.clientY-start.y;start=null;
      if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)){const rtl=getComputedStyle(this).direction==='rtl';move(index+((dx<0)!==rtl?1:-1));}
    },options);
    stage.addEventListener('pointercancel',()=>{start=null;},options);
    document.addEventListener('visibilitychange',schedule,options);
    motion.addEventListener('change',()=>{paused=motion.matches;sync();schedule();},options);
    const observer=new IntersectionObserver(entries=>{visible=entries.some(e=>e.isIntersecting);schedule();},{threshold:.2});observer.observe(this);
    this.storyCleanup=()=>{clearInterval(timer);observer.disconnect();abort.abort();this.storyReady=false;};sync();show(0);
  }
  disconnectedCallback(){this.storyCleanup?.();}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["newsletter-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
  const trigger = event.target.closest('[data-aurrelle-welcome-form]');
  if (!trigger) return;
  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(['openForm', trigger.dataset.formId]);
});
  } catch(e) { console.error(e); }
})();

})();
